import type { RootState } from '~/redux/store';
import type { User } from '~/types/models';
import type { IRestIndexParams } from '~/types/states';

export const getItem = (state: RootState): User | null => state.users.item;

export const getParams = (state: RootState): IRestIndexParams<User> => ({
  sortBy: state.users.sortBy,
  page: state.users.page,
  pageSize: state.users.pageSize,
  with: state.users.with.join(','),
  ...state.users.filters,
});
